import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActionType, PersonNotificationDto } from '@nx-ratenow/shared/models';
import * as NotificationActions from './notifications.actions';
import * as NotificationSelectors from './notifications.selectors';

@Injectable()
export class NotificationsFacade {
  notifications$ = this.store.select(NotificationSelectors.getNotifications);

  scheduled$ = this.store.select(NotificationSelectors.getScheduledNotifications);

  counter$ = this.store.select(NotificationSelectors.getCounter);

  action$ = this.store.select(NotificationSelectors.getCurrentAction);

  getNotifications() {
    this.store.dispatch(NotificationActions.getNotifications());
  }

  sendAction(actionType: ActionType, notification: PersonNotificationDto) {
    this.store.dispatch(
      NotificationActions.sendAction({
        actionType,
        notification
      })
    );
  }

  constructor(private store: Store) {}
}
